// extracted by mini-css-extract-plugin
export default {"blankState":"mPxZkhWRvi_0s5FVq9tA","cactus":"MhRbvoJKclHXZFF1gLpp","title":"xShD_6zaT03HMmrx078u"};